export default {
  zh: {
    loadMore: '加载更多'
  },
  en: {
    loadMore: 'Load More'
  }
}



// WEBPACK FOOTER //
// ./src/components/loadMore/lang.js